export const userAccount = {
	miniLogin: {
		signInRegister: 'Sign In',
	}
};